import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Kirkland from '../../components/Kirkland/Kirkland'

const Kirklandpage = () => {
    return (
        <div>
        <Navbar/>
        <Kirkland/>



        <Footer/>

        </div>
    )
}

export default Kirklandpage